import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import {
  QualificationTrainingProviderType,
  QualificationTrainings,
} from '@wilson/interfaces';
import { LocalizationState } from '@wilson/localization';
import { NzDividerModule } from 'ng-zorro-antd/divider';

@Component({
  selector: 'wilson-training-qualifications-delete-or-cancel-modal',
  imports: [CommonModule, NzDividerModule, TranslatePipe],
  templateUrl:
    './training-qualifications-delete-or-cancel-modal.component.html',
  styleUrl: './training-qualifications-delete-or-cancel-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationsDeleteOrCancelModalComponent {
  @Input() areDigitalProviders!: boolean;
  @Input() areNonDigitalProviders!: boolean;
  @Input() set selectedQualificationTrainings(
    qualificationTrainings: QualificationTrainings[],
  ) {
    qualificationTrainings.forEach((qualificationTraining) => {
      if (
        qualificationTraining.organizationalUnitQualificationTrainingProvider
          .qualificationTrainingProvider.providerType ===
        QualificationTrainingProviderType.Digital
      ) {
        this.digitalQualificationTrainingLists.push(
          this.generateQualificationTrainingListItem(qualificationTraining),
        );
      } else {
        this.nonDigitalQualificationTrainingLists.push(
          this.generateQualificationTrainingListItem(qualificationTraining),
        );
      }
    });
  }

  protected digitalQualificationTrainingLists: string[] = [];
  protected nonDigitalQualificationTrainingLists: string[] = [];
  protected store = inject(Store);

  protected generateQualificationTrainingListItem(
    qualificationTraining: QualificationTrainings,
  ): string {
    const entityLang = this.store.selectSnapshot(
      LocalizationState.getEntityLang,
    );
    const qualificationName = qualificationTraining.qualifications
      .map((qualification) => qualification[entityLang])
      .join(', ');

    return `${qualificationTraining.user.firstName} ${qualificationTraining.user.lastName} - ${qualificationName} - ${qualificationTraining.organizationalUnitQualificationTrainingProvider.qualificationTrainingProvider.name}`;
  }
}
